import { Instagram, Facebook } from "lucide-react";
import Reveal from "@/components/base/Reveal";
import { company } from "@/mocks/home";

export default function SocialFollow() {
  return (
    <section id="redes" className="relative w-full bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-container px-4 md:px-6 lg:px-10">
        <Reveal>
          <div className="flex flex-col items-center justify-between gap-7 rounded-lg border border-background-200 bg-background-100 px-7 py-8 md:flex-row md:px-10">
            <div className="text-center md:text-left">
              <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3.5 py-1.5 text-xs font-semibold uppercase tracking-[0.16em] text-secondary-900">
                <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
                Redes sociais
              </span>
              <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
                Siga-nos nas redes sociais
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-base">
                Acompanhe novidades, dicas e o dia a dia da Porta31.
              </p>
            </div>

            <div className="flex items-center gap-4">
              <a
                href={company.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram da Porta31 Condomínios"
                className="flex h-14 w-14 cursor-pointer items-center justify-center rounded-full bg-secondary-950 text-background-50 transition-all duration-300 hover:scale-110 hover:bg-primary-600"
              >
                <Instagram className="h-6 w-6" />
              </a>
              <a
                href={company.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook da Porta31 Condomínios"
                className="flex h-14 w-14 cursor-pointer items-center justify-center rounded-full bg-secondary-950 text-background-50 transition-all duration-300 hover:scale-110 hover:bg-primary-600"
              >
                <Facebook className="h-6 w-6" />
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}